import { render, staticRenderFns } from "./ClinicPhotos.vue?vue&type=template&id=b7a0f4dc&scoped=true&"
import script from "./ClinicPhotos.vue?vue&type=script&lang=js&"
export * from "./ClinicPhotos.vue?vue&type=script&lang=js&"
import style0 from "./ClinicPhotos.vue?vue&type=style&index=0&id=b7a0f4dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a0f4dc",
  null
  
)

export default component.exports